// extracted by mini-css-extract-plugin
module.exports = {"skip-to-content-button":"_2SeL5","skipToContentButton":"_2SeL5"};